// @ts-check
/**
 * @file useGlobalErrorToasts.js
 * @location src/hooks/useGlobalErrorToasts.js
 * @role 전역 에러 이벤트 → 토스트. localStorage 저장 실패(QuotaExceeded 등)·Supabase 동기화 실패 알림.
 *   onSaveFailed 는 storage.js 가, onSyncErr 는 useSupabaseStore 가 window 이벤트로 발행.
 */
import { useEffect } from 'react';

/** @param {(msg: string, kind?: string) => void} showToast */
export function useGlobalErrorToasts(showToast) {
  useEffect(() => {
    const onSaveFailed = (e) => {
      const isQuota = e.detail?.isQuota;
      showToast(
        isQuota
          ? '저장 공간이 부족합니다. 백업으로 내보낸 뒤 정리해 주세요.'
          : '저장소에 저장하지 못했습니다.',
        'err',
      );
    };
    window.addEventListener('storage:save-failed', onSaveFailed);
    return () => window.removeEventListener('storage:save-failed', onSaveFailed);
  }, [showToast]);

  useEffect(() => {
    const onSyncErr = () => showToast('동기화에 실패했습니다. 통신 상태를 확인해 주세요.', 'err');
    window.addEventListener('supabase:error', onSyncErr);
    return () => window.removeEventListener('supabase:error', onSyncErr);
  }, [showToast]);
}
